<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.625 17.5H4.37497C4.20921 17.5 4.05025 17.4341 3.93304 17.3169C3.81584 17.1997 3.75 17.0408 3.75 16.875V3.125C3.75 2.95924 3.81584 2.80027 3.93304 2.68306C4.05025 2.56585 4.20921 2.5 4.37497 2.5H11.8752L16.25 6.875V16.875C16.25 17.0408 16.1842 17.1997 16.067 17.3169C15.9498 17.4341 15.7908 17.5 15.625 17.5V17.5Z"
      stroke="#0E0E22"
      stroke-opacity="0.4"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.875 2.5V6.875H16.2506"
      stroke="#0E0E22"
      stroke-opacity="0.4"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
